























import Vue from 'vue'
import * as echarts from 'echarts'
import EchartPre from './EchartsPre'


export default Vue.extend({
  props: {
    data: { type: Array },
    typeStr: { type: String }
  },
  watch: {
    data(val) {
      this.echarts()
    }
  },
  data() {
    return {
      isFull: false
    }
  },
  mounted() {
    this.echarts()
  },
  methods: {
    echarts() {
      const dom: any = document.getElementById('echartsPre')
      const myChart: any = echarts.init(dom) // 基于准备好的dom，初始化echarts实例
      // window.onresize = myChart.resize;  // 图表宽度自适应
      //@ts-ignore
      myChart.setOption(EchartPre(this.data,''))
    },
    fullScreen() {
      this.isFull = true;
      let fullEchart = document.getElementById('preFull');
      const myChart: any = echarts.init(fullEchart) // 基于准备好的dom，初始化echarts实例
      window.onresize = myChart.resize;  // 图表宽度自适应
      //@ts-ignore
      myChart.setOption(EchartPre(this.data,'full'))
    },
    exitFullScreen() {
      this.isFull = false
    }
  }
})
